import { useEffect } from 'react';

import { PublicPageShell } from '@/components/layout/PageShell';
import { endCompetitionSession } from '@/hooks/useCompetitionSession';

export const PodziekowaniePage = () => {
  useEffect(() => {
    void endCompetitionSession();
  }, []);

  return (
    <PublicPageShell mainClassName="items-center justify-center px-4 py-8">
      <div className="w-full max-w-lg rounded-3xl bg-white/90 px-8 py-8 text-center">
        <h1 className="text-2xl font-bold tracking-tight text-gray-800 sm:text-3xl">
          Dziękujemy!
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-500 sm:text-base">
          Twoje odpowiedzi zostały pomyślnie zapisane.
          Wyniki zostaną ogłoszone przez organizatora po zakończeniu turnieju.
        </p>
        <p className="mt-6 text-sm font-semibold" style={{ color: '#1aaedd' }}>
          Turniej Przetwórstwo Mleczarskie
        </p>
      </div>
    </PublicPageShell>
  );
};
